/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import Sqaures from '../../assets/images/foursquares.svg';
import Openbook from '../../assets/images/bookopen.svg';
import coverBook from '../../assets/images/book-cover.svg';
import Userswhite from '../../assets/images/userswhite.svg';
import Sidebar from '../../components/dashboard/Sidebar';
import Navbar from '../../components/dashboard/Navbar';
import { useDispatch } from 'react-redux';
import { setActiveTab } from '../../Store/ui/classTabs';
import { allClasses as getClasses } from '../../Store/api/professor/dashboard';
import { classInfo } from '../../Store/api/classApi';

const Classes = ({ setGotoSubject = () => {} }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [allClasses, setAllClasses] = useState([]);
  const [classesLoader, setClassesLoader] = useState(false);

  useEffect(() => {
    dispatch(classInfo({ onSuccess: () => {}, onError: () => {} }));
  }, []);

  useEffect(() => {
    setClassesLoader(true);
    dispatch(
      getClasses({
        onSuccess: (res) => {
          setAllClasses(res.data.data);
          setClassesLoader(false);
        },
        onError: () => {
          setClassesLoader(false);
        },
      })
    );
  }, []);

  const handleSubject = (tab, id) => {
    dispatch(setActiveTab(tab));
    navigate(`/dashboard/classes/${id}?currentTab=${tab}`);
  };

  const today = new Date().setHours(0, 0, 0, 0);
  const currentClasses = allClasses.filter((duClass) => new Date(duClass.startDate).setHours(0, 0, 0, 0) <= today && new Date(duClass.endDate).setHours(0, 0, 0, 0) >= today);
  const upcomingClasses = allClasses.filter((duClass) => new Date(duClass.startDate).setHours(0, 0, 0, 0) > today && new Date(duClass.endDate).setHours(0, 0, 0, 0) > today);
  const previousClasses = allClasses.filter((duClass) => new Date(duClass.startDate).setHours(0, 0, 0, 0) < today && new Date(duClass.endDate).setHours(0, 0, 0, 0) < today);

  return (
    <div className='wrapper bg-white'>
      {/* <!-- Page Sidebar --> */}
      <Sidebar userType='teacher' sideBarEvent={'classes'} setGotoSubject={setGotoSubject} />
      {/* <!-- Page Content Holder --> */}
      <div id='content' className='bg-white'>
        <div className='content_dashborad_inner bg-white'>
          {/* <!-- navbar --> */}
          <Navbar sideBarEvent='classes' />
          <div className='bg-white'>
            <div className='main_section_content bg-white'>
              <div className='center_content full_width bg-white p-0' style={{ zIndex: 1 }}>
                <div className='d-flex align-items-center justify-content-between sticky-top bg-white'>
                  <h1 className='ft_18 mb_24 margn_top'>CURRENT CLASSES</h1>
                  <button type='button' onClick={() => {
                    localStorage.setItem('activeClassTab', 0);
                    localStorage.removeItem('class');
                    navigate(`/signup/createClass/?back_to=classes`)
                  }}
                  className='cursor save-btn rounded-0 text-uppercase'>
                    Add New Class --&gt;
                  </button>
                </div>
                <div className='wrap_books' style={{ minHeight: '450px' }}>
                  {classesLoader ? (
                    'Loading...'
                  ) : (
                    <Fragment>
                      {currentClasses.length === 0 && 'No classes found'}
                      {currentClasses.map((item, index) => (
                        <div className='ashrf1' key={index}>
                          <div className='books_ar_shw ashrf'>
                            <img src={item?.book?.coverImage || item?.book?.classesBookCoverUrl || coverBook} alt='img' height={400} style={{ objectFit: 'cover' }} />
                            <div className='overly'>
                              <div className='overly_top'>
                                <img
                                  src={Sqaures}
                                  alt='overview'
                                  className='cursor'
                                  onClick={() => {
                                    handleSubject('overview', item._id);
                                  }}
                                />
                              </div>
                              <hr />
                              <div className='overly_bot '>
                                <img
                                  src={Openbook}
                                  alt='classes managment'
                                  className='cursor'
                                  style={{ width: '41%' }}
                                  onClick={() => {
                                    handleSubject('settings', item._id);
                                  }}
                                />
                                <div className='virticle_line'></div>
                                {/*<div style={{width:"1px", height:"100%", background:"white", opacity:"1"}}></div>*/}
                                <img
                                  src={Userswhite}
                                  alt='std managment'
                                  className='cursor'
                                  style={{ width: '41%' }}
                                  onClick={() => {
                                    handleSubject('students', item._id);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            // style={{width: "100%", padding: "8px"}}
                            className='current_class_content  '
                          >
                            <h5 className='ft_14 fw-500 grey_900 '>
                              {item.courseName}
                              {/* {item.book.author}{" "}
                              {getAcademicSeason(new Date(item.startDate))}{" "}
                              {new Date(item.startDate).getFullYear()} */}
                            </h5>
                            <h5 className='ft_14 fw-500 grey_900 '>with {item?.book?.author}</h5>
                          </div>
                        </div>
                      ))}
                    </Fragment>
                  )}
                </div>
                <div className='line-claass'></div>
                <h1 className='ft_18 mb_24 ft_18 sticky-top zIndex bg-white top-5'>UPCOMING CLASSES</h1>
                <div
                  className='wrap_books wrap_books_previous cursor'
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '32px',
                    justifyContent: 'flex-start',
                    marginBottom: '32px',
                  }}
                >
                  {classesLoader ? (
                    'Loading...'
                  ) : (
                    <Fragment>
                      {upcomingClasses.map((item, index) => (
                        <div className='ashrf1' key={index}>
                          <div className='books_ar_shw ashrf'>
                            <img src={item?.book?.coverImage || item?.book?.classesBookCoverUrl || coverBook} alt='img' height={400} style={{ objectFit: 'contain' }} />
                            <div className='overly'>
                              <div className='overly_top'>
                                <img
                                  src={Sqaures}
                                  alt='overview'
                                  className='cursor'
                                  onClick={() => {
                                    handleSubject('overview', item._id);
                                  }}
                                />
                              </div>
                              <hr />
                              <div className='overly_bot '>
                                <img
                                  src={Openbook}
                                  alt='classes managment'
                                  className='cursor'
                                  style={{ width: '41%' }}
                                  onClick={() => {
                                    handleSubject('settings', item._id);
                                  }}
                                />
                                <div className='virticle_line'></div>
                                {/*<div style={{width:"1px", height:"100%", background:"white", opacity:"1"}}></div>*/}
                                <img
                                  src={Userswhite}
                                  alt='std managment'
                                  className='cursor'
                                  style={{ width: '41%' }}
                                  onClick={() => {
                                    handleSubject('students', item._id);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            // style={{width: "100%", padding: "8px"}}
                            className='current_class_content  '
                          >
                            <h5 className='ft_14 fw-500 grey_900 '>
                              {item.courseName}
                              {/* {item.book.author}{" "}
                            {getAcademicSeason(new Date(item.startDate))}{" "}
                            {new Date(item.startDate).getFullYear()} */}
                            </h5>
                            <h5 className='ft_14 fw-500 grey_900 '>with {item?.book?.author}</h5>
                          </div>
                        </div>
                      ))}{' '}
                    </Fragment>
                  )}
                </div>
                <h1 className='ft_18 mb_24 ft_18 sticky-top zIndex bg-white top-7'>PREVIOUS CLASSES</h1>
                <div
                  className='wrap_books wrap_books_previous cursor'
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '32px',
                    justifyContent: 'flex-start',
                  }}
                >
                  {classesLoader ? (
                    'Loading...'
                  ) : (
                    <Fragment>
                      {previousClasses.map((item, index) => (
                        <div className='ashrf1' key={index}>
                          <div className='books_ar_shw ashrf'>
                            <img src={item?.book?.coverImage || item?.book?.classesBookCoverUrl || coverBook} alt='img' height={400} style={{ objectFit: 'contain' }} />
                            <div className='overly'>
                              <div className='overly_top'>
                                <img
                                  src={Sqaures}
                                  alt='overview'
                                  className='cursor'
                                  onClick={() => {
                                    handleSubject('overview', item._id);
                                  }}
                                />
                              </div>
                              <hr />
                              <div className='overly_bot '>
                                <img
                                  src={Openbook}
                                  alt='classes managment'
                                  className='cursor'
                                  style={{ width: '41%' }}
                                  onClick={() => {
                                    handleSubject('settings', item._id);
                                  }}
                                />
                                <div className='virticle_line'></div>
                                {/*<div style={{width:"1px", height:"100%", background:"white", opacity:"1"}}></div>*/}
                                <img
                                  src={Userswhite}
                                  alt='std managment'
                                  className='cursor'
                                  style={{ width: '41%' }}
                                  onClick={() => {
                                    handleSubject('students', item._id);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            // style={{width: "100%", padding: "8px"}}
                            className='current_class_content  '
                          >
                            <h5 className='ft_14 fw-500 grey_900 '>
                              {item.courseName}
                              {/* {item.book.author}{" "}
                            {getAcademicSeason(new Date(item.startDate))}{" "}
                            {new Date(item.startDate).getFullYear()} */}
                            </h5>
                            <h5 className='ft_14 fw-500 grey_900 '>with {item?.book?.author}</h5>
                          </div>
                        </div>
                      ))}{' '}
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Classes;
